import { FormProvider } from "react-hook-form";
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/view/components/ui/dialog";
import { BasicInput } from "@/view/components/BasicInput";
import { Button } from "@/view/components/ui/button";
import { cpfMask } from "@/app/utils/cpfFormater";
import { phoneMask } from "@/app/utils/phoneFormater";
import useGenerateAuthorizationModal from "./useGenerateAuthorizationModal";

interface GenerateAuthorizationModalProps {
  onContinue: () => void;
  onBack: () => void;
}

export default function GenerateAuthorizationModal({
  onContinue,
  onBack,
}: GenerateAuthorizationModalProps) {
  const { form, submitModal, loading, isFetchingCustomer } =
    useGenerateAuthorizationModal({
      onContinue,
    });

  const {
    formState: { errors },
  } = form;

  return (
    <DialogContent className="sm:max-w-lg">
      <DialogHeader>
        <DialogTitle className="text-xl font-semibold text-black01">
          Gerar autorização
        </DialogTitle>
        <DialogDescription className="!mt-0 text-base text-black04">
          Informe os dados abaixo para gerar o link de autorização
        </DialogDescription>
      </DialogHeader>
      <form onSubmit={submitModal}>
        <FormProvider {...form}>
          <div className="grid grid-cols-1 gap-5">
            <BasicInput
              name="cpf"
              label="CPF"
              error={errors.cpf?.message}
              onInput={cpfMask}
              maxLength={14}
            />
            {isFetchingCustomer && (
              <p className="-mt-3 text-sm text-black04">
                Buscando dados do cliente...
              </p>
            )}
            <BasicInput
              name="name"
              label="Nome completo"
              error={errors.name?.message}
            />
            <BasicInput
              name="email"
              label="E-mail"
              error={errors.email?.message}
            />
            <BasicInput
              name="phone"
              label="Telefone"
              error={errors.phone?.message}
              onInput={phoneMask}
            />
            <BasicInput
              name="birthDate"
              type="date"
              label="Data de nascimento"
              error={errors.birthDate?.message}
            />
          </div>

          <div className="mt-8 flex justify-end gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={onBack}
              className="w-[160px] rounded-full text-primary"
            >
              Voltar
            </Button>
            <Button
              type="submit"
              className="w-[160px] rounded-full font-semibold text-white"
              isLoading={loading}
              disabled={loading}
            >
              Continuar
            </Button>
          </div>
        </FormProvider>
      </form>
    </DialogContent>
  );
}
